import React from "react";
/* eslint-disable */
import {
  Box, Card, Grid, CardContent, Divider, CardHeader,
  TableBody, TableCell, TableContainer, TableHead, TableRow, Table, TableFooter
} from '@material-ui/core';


export default class ComponentToPrint extends React.Component {

  render() {
    const advancePaymentData = this.props.advancedPaymentList;
    const data = this.props.searchData;

    return (
      <div>
        <h3><center><u>Cost of Product Report</u></center></h3>
        <div>&nbsp;</div>
        {/* <h4><center>{data.groupName}</center></h4>
        <h4><center>Fresh Collection Center - {data.operationEntityID}</center></h4>
        <h4><center>{data.startDate} - {data.endDate}</center></h4> */}
        <div>&nbsp;</div>
        <Box minWidth={1050}>
            <TableContainer style={{ marginLeft: '5px' }}>
              <Table aria-label="caption table">
                <TableHead>
                  <TableRow>
                    <TableCell align={'left'}>Date</TableCell>
                    <TableCell align={"left"}>FCC</TableCell>
                    <TableCell align={'left'}>Activity Name</TableCell>
                    <TableCell align={'left'}>Plot/Crop</TableCell>
                    <TableCell align={'left'}>Description</TableCell>
                    <TableCell align={'right'}>Total Expenses(Rs)</TableCell>
                    <TableCell align="center">Image </TableCell>
                    
                  </TableRow>
                </TableHead>
                <TableBody>
                  {advancePaymentData.map((data, index) => (
                    <TableRow key={index}>
                       <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none" }}>
                        {data.activityDate.split('T')[0]}
                      </TableCell>
                      <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none" }}>
                        {data.factoryName}
                      </TableCell>
                      <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none" }}>
                        {data.activityName}
                      </TableCell>
                      <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none" }}>
                        {data.plotName}
                      </TableCell>
                      <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none" }}>
                        {data.activityDescription}
                      </TableCell>
                      <TableCell align={'right'} component="th" scope="row" style={{ borderBottom: "none" }}>
                        {data.value.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                      </TableCell>
                      <TableCell align="center"component="th" scope="row" style={{ borderBottom: "none" }}>
                         {data.imageLink ? (
                            <img 
                             src={data.imageLink} 
                              alt="Activity" 
                              style={{ width: '50px', height: '50px', objectFit: 'cover', cursor: 'pointer' }}
                              />
                               ) : (
                              <span>No image</span>
                              )}
                             </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
      </div>
      
    );
  }
}
